import { runtime } from '../../Runtime';
import { RuntimeSchedule } from './RuntimeSchedule';
export class RuntimeScheduleNextAnimationFrame extends RuntimeSchedule {
    addToNext(actionFunc, options = {}) {
        if (runtime.isServerRuntime) {
            actionFunc();
            return;
        }
        const task = this.addTask(actionFunc, options);
        if (!task)
            return;
        window.requestAnimationFrame(this.processCurrentBatch);
        return task.promise;
    }
}
